import { render, staticRenderFns } from "./appPlatform.vue?vue&type=template&id=55341c58&scoped=true"
import script from "./appPlatform.vue?vue&type=script&lang=js"
export * from "./appPlatform.vue?vue&type=script&lang=js"
import style0 from "./appPlatform.vue?vue&type=style&index=0&id=55341c58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55341c58",
  null
  
)

export default component.exports